module.exports = __webpack_public_path__ + "img/madera024.fc8275ef.jpg";